module.exports = __webpack_public_path__ + "img/840.e831d0e7.svg";